import React from "react";
import StartStep from "../../components/StartStep/StartStep";
import {Accordion, Button, Col, ProgressBar, Tab, Tabs} from "react-bootstrap";
import Container from "react-bootstrap/Container";

import ImageAddr1 from '../../assets/images/addr1.png'
import ImageAddr2 from '../../assets/images/addr2.png'
import Row from "react-bootstrap/Row";

const AboutUs = () => {
    return (
        <div>
            <StartStep>
                <h1>Оформление электронного пропуска</h1>
            </StartStep>

            <Container className="greyBorder">
                <Tabs
                    defaultActiveKey="addr1"
                    id="uncontrolled-tab-example"
                    className="mb-4"
                >
                    <Tab eventKey="addr1" title="Адрес №1">
                        <h2>
                            Покровский бульвар, д. 11с 6
                            (корпус «Z» - «Культурный центр»), пом. Z117
                        </h2>
                        <br/>
                        <img src={ImageAddr1}/>
                        <br/><br/>
                        <p>
                            Для оформления <b>электронного</b> пропуска при себе необходимо иметь
                            - копию приказа о приеме на работу, заверенную подписью работника Отдела по кадровому
                            администрированию (каб. 501-514, Мясницкая, 20).
                        </p>
                        <br/>
                        <h2>График выдачи пропусков:</h2>
                        <p>
                            Понедельник-пятница с 10.00 до 17.30
                            <br/>
                            Технический перерыв с 13.00 до 14.00
                            <br/>
                            Суббота, воскресенье - выходной
                        </p>

                        <p>Для справок: <a href="https://www.hse.ru/org/persons/12866317">Тунёва Наталия Николаевна</a></p>
                    </Tab>
                    <Tab eventKey="addr2" title="Адрес №2">
                        <h2>
                            Мясницкая ул., д. 20
                            Бюро пропусков (вход с улицы), пом. М20-123.1
                        </h2>
                        <br/>
                        <img src={ImageAddr2}/>
                        <br/><br/>
                        <p>
                        Для оформления <b>электронного</b> пропуска при себе необходимо иметь
                        - копию приказа о приеме на работу, заверенную подписью работника Отдела по кадровому
                            администрированию (каб. 501-514, Мясницкая, 20).</p>

                        <br/>
                        <h2>График работы:</h2>
                        <p>
                            Понедельник-вторник с 9:00 до 17:00 (Технический перерыв с 12:00 до 13:00)
                            <br/>
                            Среда с 13:00 до 21:00 (Технический перерыв с 16:00 до 17:00)
                            <br/>
                            Четверг-пятница с 9:00 до 17:00 (Технический перерыв с 12:00 до 13:00)
                            <br/>
                        </p>

                        <p>Для справок: <a href="https://www.hse.ru/org/persons/409751532">Балашова Елена Михайловна</a></p>

                    </Tab>
                </Tabs>
            </Container>

            <br/><br/>

            <Container>
                <Accordion>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header><h2>Инструкция пользователя электронным пропуском*</h2></Accordion.Header>
                        <Accordion.Body>
                            <p>Электронный пропуск работника (далее – ЭП) является основным документом для прохода на территорию НИУ ВШЭ и выдается пользователю (работнику,) под расписку для прохода через специально оборудованные входы (турникеты, двери) на объекты НИУ ВШЭ. </p>
                            <p>ЭП позволяет беспрепятственно проходить на все объекты НИУ ВШЭ на основании оформленного права доступа в соответствии с общим режимом работы НИУ ВШЭ, установленным правилами внутреннего распорядка, действующими в НИУ ВШЭ (в том числе, позволяет осуществлять вход и выход в компьютерные классы), кроме воскресенья. </p>
                            <p>
                                <b>1. Для прохода необходимо:</b>
                                – поднести ЭП на расстояние не более 3 (трех) сантиметров любой стороной параллельно к считывателю или коснуться его;
                                <br/>
                                – убедиться, что загорелся зеленый сигнал (стрелка-указатель), и пройти через турникет (дверь).
                                <br/>
                                В случае несрабатывания турникета или двери:
                                <br/>
                                – повторить попытку прохода через 30 секунд;
                                <br/>
                                – при несостоявшейся следующей попытке прохода обратиться к сотруднику охраны, предъявив ему ЭП. Сотрудник охраны обязан изъять неработающий ЭП и передать в Управление для определения причины несрабатывания ЭП. В этой ситуации вход разрешается по разовому пропуску, оформленному в СУРП, либо по предъявлению документа, удостоверяющего личность.
                            </p>
                            <p>
                                <b>2. При поломке, утере, повреждении ЭП </b>
                                дубликат выдается пользователю на основании его личного заявления (приложение 3 к Регламенту).
                                <br/>
                                ЭП является собственностью НИУ ВШЭ. Пользователь обязан бережно и аккуратно хранить ЭП. По окончании периода обучения или работы в НИУ ВШЭ ЭП в обязательном порядке подлежит возврату в Управление. В случае невозврата ЭП блокируется, допуск на объекты НИУ ВШЭ по нему не разрешается.
                            </p>
                            <p>
                                <b>Запрещается </b> вход на объекты НИУ ВШЭ по ЭП другого пользователя, передача ЭП другому лицу. В случае выявления факта нарушения, ЭП изымается сотрудником охраны или представителем администрации объекта. Лица, выявленные в нарушении установленного порядка пользования ЭП, подвергаются дисциплинарному взысканию. В этом случае проход на объекты НИУ ВШЭ будет разрешен только по разовому пропуску, выдаваемому в установленном порядке.
                            </p>
                            <p>
                                <b>3. Порядок обращения с ЭП.</b>
                                <br/>
                                ЭП содержит встроенное электронное устройство и требует бережного обращения и хранения.
                                <br/>
                                ЭП не рекомендуется:
                                <br/>
                                – подвергать охлаждению ниже - 40° С и нагреву свыше +60° С;
                                <br/>
                                – помещать во влажную и агрессивную среду;
                                <br/>
                                – подвергать механическому воздействию - сгибать, скручивать и др.;
                                <br/>
                                – подвергать воздействию электромагнитных полей.
                            </p>
                            <p><small>* Приложение 2 к Регламенту о пропускной системе Национального исследовательского университета «Высшая школа экономики</small></p>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header><h2>Локальные нормативные акты НИУ ВШЭ</h2></Accordion.Header>
                        <Accordion.Body>
                            <h5><a href="https://www.hse.ru/data/2021/09/06/1469457218/%D0%9F%D0%BE%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5 %D0%BE %D0%B2%D0%BD%D1%83%D1%82%D1%80%D0%B8%D0%BE%D0%B1%D1%8A%D0%B5%D0%BA%D1%82%D0%BE%D0%B2%D0%BE%D0%BC %D0%B8 %D0%BF%D1%80%D0%BE%D0%BF%D1%83%D1%81%D0%BA%D0%BD%D0%BE%D0%BC %D1%80%D0%B5%D0%B6%D0%B8%D0%BC%D0%B5 %D0%9D%D0%98%D0%A3 %D0%92%D0%A8%D0%AD.docx">Положение о внутриобъектовом и пропускном режиме НИУ ВШЭ</a></h5>
                            <h5><a href="https://www.hse.ru/data/2022/04/12/1790260792/%D0%A0%D0%B5%D0%B3%D0%BB%D0%B0%D0%BC%D0%B5%D0%BD%D1%82 %D0%BE %D0%BF%D1%80%D0%BE%D0%BF%D1%83%D1%81%D0%BA%D0%BD%D0%BE%D0%B9 %D1%81%D0%B8%D1%81%D1%82%D0%B5%D0%BC%D0%B5 %D0%9D%D0%98%D0%A3 %D0%92%D0%A8%D0%AD.docx">Регламент о пропускной системе НИУ ВШЭ</a></h5>
                            <h5><a href="https://www.hse.ru/data/2022/03/16/1809424501/%D0%B8%D0%BD%D1%81%D1%82%D1%80%D1%83%D0%BA%D1%86%D0%B8%D1%8F %D0%B0%D0%BD%D1%82%D0%B8%D1%82%D0%B5%D1%80%D1%80%D0%BE%D1%80 2022.pdf">Инструкция о правилах поведения в условиях возникновения террористической опасности</a></h5>
                            <h5><a href="https://www.hse.ru/data/2021/07/02/1432282068/INSTRUCTIONS on What to Do During a Terrorist Attack.pdf">Instructions on What to Do During a Terrorist Attack</a></h5>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </Container>

            <br/>
            <Container>
                <p><a href="https://www.hse.ru/aup/security/ubr">Дирекция по безопасности</a></p>
            </Container>

            <br/><br/>

            <Container>
                <Row className="justify-content-md-center">
                    <Col md={2}>
                        <Button variant="outline-primary" style={{width: "100%"}} href="/step2">Назад</Button>{' '}
                    </Col>
                    <Col md={1}></Col>
                    <Col md={6} style={{ textAlign: "center", paddingTop: "6px"}}>
                        <ProgressBar now={27}/>
                        <span>Шаг 3 из 11</span>
                    </Col>
                    <Col md={1}></Col>
                    <Col md={2}>
                        <Button variant="outline-primary" style={{width: "100%"}} href="/step4">Вперед</Button>{' '}
                    </Col>
                </Row>
            </Container>

        </div>
    );
};

export default AboutUs;